import { SVGAttributes } from 'react';

type IconProps = SVGAttributes<SVGElement>;

const ArrowUpIcon = ({ color = 'currentColor', ...svgProps }: IconProps) => {
  return (
    <svg
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <line
        fill="none"
        stroke="#000000"
        strokeWidth="2"
        strokeMiterlimit="10"
        x1="16"
        y1="6"
        x2="16"
        y2="28"
      />
      <polyline
        fill="none"
        stroke="#000000"
        strokeWidth="2"
        strokeMiterlimit="10"
        points="7.5,14 16,5.5 24.5,14 "
      />
    </svg>
  );
};

export default ArrowUpIcon;
